(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-condition-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('conditionModal');
  const openBtn = document.getElementById('modalOpen');
  const closeBtn = document.getElementById('modalClose');
  const scrollContainer = modal.querySelector('.condition-modal__content');

  if (!modal || !openBtn || !scrollContainer) return;

  const openModal = () => {
  modal.style.display = 'flex';
  
  scrollContainer.scrollTop = 0;

  requestAnimationFrame(() => {
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
  });
  
  document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
  modal.classList.remove('is-active');
  modal.setAttribute('aria-hidden', 'true');
  
  setTimeout(() => {
    if (!modal.classList.contains('is-active')) {
    modal.style.display = 'none';
    }
  }, 400);
  
  document.body.style.overflow = '';
  };

  openBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
  if (e.target === modal) closeModal();
  });
  
  window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && modal.classList.contains('is-active')) {
    closeModal();
  }
  });
});
  } catch(e) { console.error(e); }
})();

})();
